import { render, staticRenderFns } from "./InserirAtualizarDotacaoForm.vue?vue&type=template&id=1d59a81e"
import script from "./InserirAtualizarDotacaoForm.vue?vue&type=script&lang=js"
export * from "./InserirAtualizarDotacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports